import { stateT } from "../../types";

export const getObjectProcessData = (state: stateT) => {
  return state.ui.objectProcessData;
};

export const getProcessObjectImageHash = (state: stateT): string | null => {
  const objectProcessData = getObjectProcessData(state);
  return objectProcessData.imageHash;
};
